import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Cookie-based admin auth: the session token lives in an HttpOnly cookie
// set by /api/admin/login. `withCredentials` ensures the browser attaches
// the cookie to every /api call (both same-origin and cross-origin CORS
// requests). No JWT is ever handed to the frontend.
const client = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatError(err) {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (d?.msg) return d.msg;
  return err?.message || "Something went wrong. Please try again.";
}

export default client;
